import { render, staticRenderFns } from "./TradeNews.vue?vue&type=template&id=3cd0e24a&scoped=true"
import script from "./TradeNews.vue?vue&type=script&lang=js"
export * from "./TradeNews.vue?vue&type=script&lang=js"
import style0 from "./TradeNews.vue?vue&type=style&index=0&id=3cd0e24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0e24a",
  null
  
)

export default component.exports